import thoraPic from "@/public/images/artists/thora.png";
import { Artist } from "@/types/types";

export const thora = {
  id: "171",
  name: "Thora",
  image: thoraPic,
  description: `Thora's voice embodies a unique timbral blend that seamlessly merges the raw edge of modern rock with the emotional depth of alternative metal. Her tone is richly textured, featuring a controlled rasp that brings harmonic complexity and grit without losing clarity. When the intensity rises, she can shift into a fierce, precise growl or scream, adding a visceral layer to her sound.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fthora-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Growl", "Rock"],
      secondary: ["Experimental", "Scream"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 57,
        high: 68,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
